import axios from 'axios';
import store from '../store';
import addError from './AddError';

export const NO_MORE_LEADS = 'NO_MORE_LEADS';
export const REQUESTED_MORE_LEADS = 'REQUESTED_MORE_LEADS';
export const RECEIVED_MORE_LEADS = 'RECEIVED_MORE_LEADS';
export const REQUEST_MORE_LEADS_FAILED = 'REQUEST_MORE_LEADS_FAILED';

let controller = null;

const getLeads = (params = {}) => (
  (dispatch) => {
    if (!store.getState().leads.next_page_url) {
      dispatch({
        type: NO_MORE_LEADS,
      });

      return null;
    }

    dispatch({
      type: REQUESTED_MORE_LEADS,
    });

    if (controller != null) {
      controller.abort();
    }
    controller = new AbortController();

    if (params.type.includes(',')) {
      // eslint-disable-next-line no-param-reassign
      params.types = params.type.split(',');
      // eslint-disable-next-line no-param-reassign
      delete params.type;
    }

    return axios.get(store.getState().leads.next_page_url, {
      params,
      signal: controller.signal,
    }).then((response) => {
      dispatch({
        type: RECEIVED_MORE_LEADS,
        leads: response.data.data,
        next_page_url: response.data.next_page_url,
        total: response.data.total,
        to: response.data.to,
        params,
      });
    }).catch((error) => {
        if (error.name === 'AbortError') {
            return;
        }
      let text = 'An unexpected error has occurred';
      if (typeof error.response === 'object') {
        text = error.response.data;
      }

      dispatch({
        type: REQUEST_MORE_LEADS_FAILED,
      });

      return store.dispatch(addError({
        text,
        originalError: error,
      }));
    });
  }
);

export default getLeads;
